import t from "typy";

export function DefaultValuePropagator(...argsSetter) {
    let functions = argsSetter.filter((e) => t(e).isFunction);

    let options = argsSetter.find((e) => t(e).isObject);

    let finish = t(options, 'onFinish').safeFunction;

    return function (...argsValues) {
        if (argsValues.length !== functions.length)
            throw new Error('Value count does not match setter count');

        return async (event) => {
            t(options, 'stopPropagation').safeBoolean && event.stopPropagation();
            for (const e of functions) {
                let i = functions.indexOf(e);
                if (t(argsValues[i]).isArray) {
                    await e(...argsValues[i]);
                } else {
                    await e(argsValues[i]);
                }
            }
            await finish();
        }
    }
}

export default DefaultValuePropagator